import React, { type SyntheticEvent } from 'react';
import { styled } from '@compiled/react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { fireUIAnalytics, AnalyticsEventToProps } from '@atlassian/jira-product-analytics-bridge';
import { type LinkProps, Link as RouterLink } from '@atlassian/jira-router';

export type LinkWithAnalyticsProps = LinkProps & {
	action?: string;
	actionSubject?: string;
	actionSubjectId?: string;
	attributes?: {
		[key: string]: string | boolean | number;
	};
};

export const LinkWithAnalytics = ({
	action,
	actionSubject,
	actionSubjectId = '',
	attributes = {},
	...props
}: LinkWithAnalyticsProps) => (
	<LinkWithAnalyticsBase
		{...props}
		onClick={(e: SyntheticEvent, analyticsEvent: UIAnalyticsEvent) => {
			fireUIAnalytics(analyticsEvent, actionSubjectId, attributes);
			if (props.onClick) {
				// @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
				props.onClick();
			}
		}}
	/>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Link = styled(RouterLink)({
	fontWeight: 500,
});

const LinkWithAnalyticsBase = AnalyticsEventToProps('link', {
	onClick: 'clicked',
})(Link);
